"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/formFill/Signer.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _text = require('shared/services/forms/text');

var _FilledPage = require('web/components/Forms/FilledPage'); var _FilledPage2 = _interopRequireDefault(_FilledPage);
var _view = require('./view');

/* The guided signer (D-154): the form's page on top, scrolled to the
 * highlighted field, and one question for that field below it, with Next in
 * the same place every step. After the last field comes a review, then Sign
 * and submit. Staff and auto fields are drawn on the page, never asked.
 * Nothing is sent before Sign and submit. */



const DATE_INPUT = 'YYYY-MM-DD'

const MIN_NAME = 2

/* A date field for the day of signing ("Date", "Today's date", "Date
 * signed", "Signature date") starts on today; a date of birth or any other
 * date starts empty. */
const isSigningDate = (field) =>
  field.type === 'date' &&
  (/^\s*date\s*:?\s*$/i.test(field.label) || /\b(today|sign(ed|ing|ature)?)\b/i.test(field.label))

const answerText = (field, value) => {
  if (!_optionalChain([value, 'optionalAccess', _ => _.trim, 'call', _2 => _2()])) return ''
  if (field.type === 'checkbox') return value === 'true' ? 'Yes' : ''
  if (field.type === 'date') return _text.formDate.call(void 0, value)
  return value
}

/* What a step says when it is left empty. */
const missingText = (step) =>
  step.kind === 'signature' ? 'Type your full name to sign.'
    : step.field.type === 'choice' ? 'Choose one to go on.'
      : step.field.type === 'checkbox' ? 'Check this box to go on.'
        : 'Fill this in to go on.'

const stepError = (step, values, signerName) => {
  if (step.kind === 'signature') return signerName.trim().length < MIN_NAME ? missingText(step) : ''
  const { field } = step
  return !field.required || _view.isFilled.call(void 0, field, values[field.id]) ? '' : missingText(step)
}

const questionOf = (step) =>
  step.kind === 'signature' ? 'Sign your name' : step.field.label.trim() || 'Fill this in'

const hintOf = (step) =>
  step.kind === 'signature' ? ''
    : isSigningDate(step.field) ? 'Today is filled in. Change it if you need to.'
      : step.field.required ? '' : 'You can leave this empty.'

/* The on-screen keyboard is up: where the visible area is, else null. A
 * browser pans the page by less than the keyboard's height (iOS Safari), so
 * the signer pins itself to the visible area instead: a strip of the page,
 * the question, and Next right above the keyboard. */
const KEYBOARD_MIN_HEIGHT = 150


const useKeyboardArea = () => {
  const [area, setArea] = _react.useState(null)
  _react.useEffect.call(void 0, () => {
    const vv = window.visualViewport
    if (!vv) return undefined
    const update = () => {
      const open = Math.abs(vv.scale - 1) < 0.01 &&
        document.documentElement.clientHeight - vv.height > KEYBOARD_MIN_HEIGHT
      setArea(a => {
        if (!open) return null
        return a && a.top === vv.offsetTop && a.height === vv.height ? a : { top: vv.offsetTop, height: vv.height }
      })
    }
    update()
    vv.addEventListener('resize', update)
    vv.addEventListener('scroll', update)
    return () => {
      vv.removeEventListener('resize', update)
      vv.removeEventListener('scroll', update)
    }
  }, [])
  return area
}

/* The phone's text size is very large (iOS Larger Text): the page drops its
 * brand row and title row, so the question keeps the height. */
const LARGE_TEXT_PX = 30

const useLargeText = () => {
  const ref = _react.useRef(null)
  const [large, setLarge] = _react.useState.call(void 0, false)
  _react.useLayoutEffect.call(void 0, () => {
    const check = () => {
      if (ref.current) setLarge(parseFloat(window.getComputedStyle(ref.current).fontSize) >= LARGE_TEXT_PX)
    }
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])
  return { ref, large }
}

/* Keeps the highlighted field in the middle of the part of the page you can
 * see. With the keyboard up the browser pans the page, so the visible part is
 * what is inside the visual viewport. */
const useFieldInView = (step, typing) => {
  const pageRef = _react.useRef(null)
  const fieldRef = _react.useRef(null)

  const scroll = _react.useCallback.call(void 0, (smooth) => {
    const pane = pageRef.current
    const field = fieldRef.current
    if (!pane || !field) return
    const pr = pane.getBoundingClientRect()
    const fr = field.getBoundingClientRect()
    const vv = window.visualViewport
    const top = vv ? Math.max(pr.top, vv.offsetTop) : pr.top
    const bottom = vv ? Math.min(pr.bottom, vv.offsetTop + vv.height) : pr.bottom
    const middle = bottom > top ? (top + bottom) / 2 : (pr.top + pr.bottom) / 2
    const target = pane.scrollTop + fr.top + fr.height / 2 - middle
    if (typeof pane.scrollTo === 'function') {
      pane.scrollTo({ top: Math.max(0, target), behavior: smooth ? 'smooth' : 'auto' })
    }
  }, [])

  _react.useLayoutEffect.call(void 0, () => scroll(!typing), [scroll, step, typing])

  _react.useEffect.call(void 0, () => {
    const vv = window.visualViewport
    if (!vv) return undefined
    let frame = 0
    const later = () => {
      // A pinch zoom pans the visual viewport too: leave the signer's view.
      if (Math.abs(vv.scale - 1) > 0.01) return
      cancelAnimationFrame(frame)
      frame = requestAnimationFrame(() => scroll(false))
    }
    // Safari pans the visual viewport after the keyboard is up (a scroll,
    // not a resize), which moves the part of the page you can see.
    vv.addEventListener('resize', later)
    vv.addEventListener('scroll', later)
    window.addEventListener('resize', later)
    return () => {
      cancelAnimationFrame(frame)
      vv.removeEventListener('resize', later)
      vv.removeEventListener('scroll', later)
      window.removeEventListener('resize', later)
    }
  }, [scroll])

  return { pageRef, fieldRef }
}










/* Every page with what is filled so far drawn in its box, as the signed PDF
 * will stamp it (FilledPage, valueFor in SentFormView): answers as typed,
 * the signature with the signing date, X in a ticked box. */
const Pages = ({ view, values, signerName, current, pageRef, fieldRef }) => {
  const today = _moment2.default.call(void 0, ).format(_text.FORM_DATE_FORMAT)
  const name = signerName.trim().replace(/\s+/g, ' ')
  const valueOf = (f) => {
    if (f.filler === 'auto') return today
    if (f.type === 'signature') return name ? `${name}  ${today}` : ''
    const value = f.filler === 'staff' ? _optionalChain([view, 'access', _3 => _3.StaffValues, 'optionalAccess', _4 => _4[f.id]]) || '' : _optionalChain([values, 'access', _5 => _5[f.id], 'optionalAccess', _6 => _6.trim, 'call', _7 => _7()]) || ''
    return f.type === 'date' ? _text.formDate.call(void 0, value) : value
  }

  return (
    _react2.default.createElement('div', { className: "form-signer--pages", ref: pageRef, 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}
      ,  (_nullishCoalesce(view.Pages, () => ( []))).map((page, i) => (
        _react2.default.createElement('div', { className: "form-signer--page", key: page.FileKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}
          , _react2.default.createElement(_FilledPage2.default, {
            page: page,
            pageIndex: i,
            fields: _nullishCoalesce(view.Fields, () => ( [])),
            valueOf: valueOf,
            rows: _nullishCoalesce(view.Rows, () => ( [])),
            label: `Page ${i + 1}`,
            current: _optionalChain([current, 'optionalAccess', _8 => _8.id]),
            currentRef: fieldRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}
          )
        )
      )) 
    )
  )
}











const Question = ({ step, value, signerName, error, onValue, onSignerName, onNext }) => {
  const errorId = 'form-signer-error'
  const hintId = 'form-signer-hint'
  const described = [hintOf(step) && hintId, error && errorId].filter(Boolean).join(' ') || undefined
  const onEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onNext()
    }
  }
  const field = step.field
  const signing = step.kind === 'signature'
  const typed = signing || !['choice', 'checkbox'].includes(field.type)
  const type = _optionalChain([field, 'optionalAccess', _9 => _9.type])
  // One input in one place for every typed step, so moving between them
  // keeps it, its focus and the keyboard. A date or time gets its own, so
  // the phone opens its picker instead of the letter keyboard.
  const picker = !signing && (type === 'date' || type === 'time')
  const input = typed && (
    _react2.default.createElement('input', {
      key: picker ? 'picker' : 'text',
      id: "form-signer-input",
      className: _classBuilder2.default.call(void 0, 'form-signer--input', {
        'form-signer--input-short': type === 'initials' && !signing,
        'form-signer--input-bad': !!error,
      }),
      type: picker ? type : 'text',
      placeholder: signing ? 'Type your full name' : type === 'initials' ? 'Your initials' : 'Tap to type',
      value: signing ? signerName : value,
      maxLength: signing ? 200 : type === 'initials' ? 4 : 2000,
      autoComplete: signing ? 'name' : 'off',
      // Answers are mostly names, addresses and numbers, and Return means
      // Next, which on iOS accepts the autocorrection ("Collins" became
      // "Collin's").
      autoCorrect: "off",
      spellCheck: false,
      autoCapitalize: signing ? 'words' : type === 'initials' ? 'characters' : 'sentences',
      enterKeyHint: "next",
      onChange: e => (signing ? onSignerName : onValue)(e.target.value),
      onKeyDown: onEnter,
      'aria-invalid': !!error || undefined,
      'aria-describedby': described, __self: this, __source: {fileName: _jsxFileName, lineNumber: 229}}
    )
  )
  let control = null
  if (signing) {
    control = (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement('div', { className: "form-signer--preview-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 258}}, "Your signature will look like this:"     )
        , _react2.default.createElement('div', { className: "form-signer--preview", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 259}},  signerName.trim() || ' ' )
      )
    )
  } else if (type === 'choice') {
    control = (
      _react2.default.createElement('div', { className: "form-signer--choices", role: "radiogroup", 'aria-labelledby': "form-signer-question", 'aria-describedby': described, __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
        ,  (_nullishCoalesce(field.options, () => ( []))).map(option => (
          _react2.default.createElement('button', {
            key: option,
            type: "button",
            role: "radio",
            'aria-checked': value === option,
            className: _classBuilder2.default.call(void 0, 'form-signer--choice', { 'form-signer--choice-on': value === option }),
            onClick: () => onValue(option), __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}

            , _react2.default.createElement('span', { className: "form-signer--radio", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 274}} )
            ,  option 
          )
        )) 
      )
    )
  } else if (type === 'checkbox') {
    control = (
      _react2.default.createElement('button', {
        type: "button",
        role: "checkbox",
        'aria-checked': value === 'true',
        'aria-describedby': described,
        className: _classBuilder2.default.call(void 0, 'form-signer--choice', { 'form-signer--choice-on': value === 'true' }),
        onClick: () => onValue(value === 'true' ? '' : 'true'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}

        , _react2.default.createElement('span', { className: "form-signer--tick", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}},  value === 'true' ? '✓' : '' ), "Yes, check this box"

      )
    )
  }

  const hint = hintOf(step)

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('h2', { className: "form-signer--question form-signer--focus" , id: "form-signer-question", tabIndex: -1, __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}}
        ,  typed ? _react2.default.createElement('label', { htmlFor: "form-signer-input", __self: this, __source: {fileName: _jsxFileName, lineNumber: 301}},  questionOf(step) ) : questionOf(step) 
      )
      ,  hint && _react2.default.createElement('p', { className: "form-signer--hint", id: hintId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 303}},  hint ) 
      ,  input 
      ,  control 
      ,  error && _react2.default.createElement('div', { className: "form-signer--error", id: errorId, role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 306}},  error ) 
    )
  )
}

/* What the family has entered, kept by the log while it shows its calendar. */


// Tapping Back or Next leaves the keyboard up: the input keeps its focus.
const keepFocus = (e) => {
  if (document.activeElement instanceof HTMLInputElement) e.preventDefault()
}
















const Signer = ({ view, onSigned, onExit, draft, summary, consentNote, title }) => {
  const steps = _react.useMemo.call(void 0, () => _view.signerSteps.call(void 0, view), [view])
  const review = steps.length
  const [index, setIndex] = _react.useState.call(void 0, 0)
  const [fromReview, setFromReview] = _react.useState.call(void 0, false)
  const [values, setValues] = _react.useState(() => {
    if (draft) return draft.values
    const today = _moment2.default.call(void 0, ).format(DATE_INPUT)
    const prefilled = {}
    for (const s of steps) if (s.kind === 'field' && isSigningDate(s.field)) prefilled[s.field.id] = today
    return prefilled
  })
  const [signerName, setSignerName] = _react.useState.call(void 0, _nullishCoalesce(_optionalChain([draft, 'optionalAccess', _10 => _10.signerName]), () => ( '')))
  const [error, setError] = _react.useState.call(void 0, '')
  const [serverError, setServerError] = _react.useState.call(void 0, '')
  const [sending, setSending] = _react.useState.call(void 0, false)
  const questionRef = _react.useRef(null)

  const step = steps[index]
  // The page number follows the last step with a box: a signature step
  // added for a form without a signature box stays on the page before it.
  const pageField = _optionalChain([steps, 'access', _11 => _11.slice, 'call', _12 => _12(0, step ? index + 1 : steps.length), 'access', _13 => _13.reverse, 'call', _14 => _14(), 'access', _15 => _15.find, 'call', _16 => _16(s => s.field), 'optionalAccess', _17 => _17.field])
  const pageCount = _nullishCoalesce(_optionalChain([view, 'access', _18 => _18.Pages, 'optionalAccess', _19 => _19.length]), () => ( 0))
  const keyboard = useKeyboardArea()
  const { ref: rootRef, large } = useLargeText()
  const { pageRef, fieldRef } = useFieldInView(index, !!keyboard)

  // A new step starts at its top, and a screen reader hears its question,
  // unless the keyboard is up in the question (then focus stays and so does
  // the keyboard).
  // The input keeping focus means a screen reader hears no new question, so
  // a live region says it instead.
  const [spoken, setSpoken] = _react.useState.call(void 0, '')
  _react.useEffect.call(void 0, () => {
    const pane = questionRef.current
    if (!pane) return
    pane.scrollTop = 0
    const active = document.activeElement
    const kept = active instanceof HTMLInputElement && pane.contains(active)
    const now = steps[index]
    // The position makes each announcement differ, even between two steps
    // with the same question ("Fill this in").
    setSpoken(kept && now ? [`${index + 1} of ${steps.length}`, questionOf(now), hintOf(now)].filter(Boolean).join('. ') : '')
    if (!kept) _optionalChain([pane, 'access', _20 => _20.querySelector, 'call', _21 => _21('.form-signer--focus'), 'optionalAccess', _22 => _22.focus, 'call', _23 => _23({ preventScroll: true })])
  }, [index, steps])

  const goTo = (i) => {
    setError('')
    setServerError('')
    setIndex(i)
  }

  const next = () => {
    if (!step) return
    const problem = stepError(step, values, signerName)
    if (problem) {
      setError(problem)
      return
    }
    if (fromReview) {
      setFromReview(false)
      goTo(review)
    } else goTo(index + 1)
  }

  const back = () => {
    if (fromReview) {
      setFromReview(false)
      goTo(review)
    } else if (index === 0) _optionalChain([onExit, 'optionalCall', _24 => _24({ values, signerName })])
    else goTo(index - 1)
  }

  // A field found empty at submit opens on its own, and Next comes back.
  const reopen = (i, problem) => {
    setFromReview(true)
    goTo(i)
    setError(problem)
  }

  const change = (i) => {
    setFromReview(true)
    goTo(i)
  }

  const submit = () => {
    const missing = steps.findIndex(s => stepError(s, values, signerName))
    if (missing >= 0) {
      reopen(missing, stepError(steps[missing], values, signerName))
      return
    }
    const Values = {}
    for (const s of steps) {
      if (s.kind !== 'field') continue
      const v = _optionalChain([values, 'access', _25 => _25[s.field.id], 'optionalAccess', _26 => _26.trim, 'call', _27 => _27()])
      if (v) Values[s.field.id] = v
    }
    setSending(true)
    setServerError('')
    _client2.default.send('SubmitForm', { Values, SignerName: signerName.trim() })
      .then(onSigned)
      .catch((err) => {
        setSending(false)
        const ids = _nullishCoalesce(_optionalChain([err, 'optionalAccess', _28 => _28.Details, 'optionalAccess', _29 => _29.Missing]), () => ( []))
        const at = steps.findIndex(s => s.field && ids.includes(s.field.id))
        const found = steps[at]
        if (found) {
          reopen(at, missingText(found))
        } else setServerError(_optionalChain([err, 'optionalAccess', _30 => _30.Error]) || 'This form could not be sent. Please try again.')
      })
  }

  const team = view.TeamName || 'your provider'
  // At very large text sizes the consent would fill the footer and leave no
  // room for the answers, so it goes after them, in the part that scrolls.
  const consent = !step && (
    _react2.default.createElement('p', { className: "form-signer--consent", __self: this, __source: {fileName: _jsxFileName, lineNumber: 450}}, "By tapping Sign and submit, you sign this form electronically. "
                ,  team , " gets a copy."
      ,  consentNote && ` ${consentNote}` 
    )
  )
  const staff = _view.staffFields.call(void 0, view)
  const page = (_nullishCoalesce(_optionalChain([pageField, 'optionalAccess', _31 => _31.page]), () => ( 0))) + 1
  const setValue = (v) => {
    if (_optionalChain([step, 'optionalAccess', _32 => _32.kind]) !== 'field') return
    setError('')
    setValues(vs => ({ ...vs, [step.field.id]: v }))
  }
  const setName = (v) => {
    setError('')
    setSignerName(v)
  }

  return (
    _react2.default.createElement('div', {
      ref: rootRef,
      className: _classBuilder2.default.call(void 0, 'form-signer', { 'form-signer--typing': !!keyboard, 'form-signer--large': large }),
      style: keyboard ? { top: keyboard.top, height: keyboard.height } : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 468}}

      , _react2.default.createElement('div', { className: "form-signer--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 473}}
        , _react2.default.createElement('span', { className: "form-signer--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 474}},  _nullishCoalesce(title, () => ( view.FormName)) )
        ,  pageCount > 1 && _react2.default.createElement('span', { className: "form-signer--page-no", __self: this, __source: {fileName: _jsxFileName, lineNumber: 475}}, "Page " ,  page , " of "  ,  pageCount ) 
      )
      ,  staff.length > 0 && (
        _react2.default.createElement('ul', { className: "form-signer--sr-only", 'aria-label': `Filled in by ${team}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 478}}
          ,  staff.map(f => _react2.default.createElement('li', { key: f.id, __self: this, __source: {fileName: _jsxFileName, lineNumber: 479}},  f.label , ": " ,  answerText(f, _optionalChain([view, 'access', _33 => _33.StaffValues, 'optionalAccess', _34 => _34[f.id]])) )) 
        )
      ) 
      , _react2.default.createElement(Pages, { view: view, values: values, signerName: signerName, current: _optionalChain([step, 'optionalAccess', _35 => _35.field]), pageRef: pageRef, fieldRef: fieldRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 482}} )
      , _react2.default.createElement('div', { className: "form-signer--ask", ref: questionRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 483}}
        ,  step ? (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement('div', { className: "form-signer--progress", __self: this, __source: {fileName: _jsxFileName, lineNumber: 486}}
              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 487}},  index + 1 , " of "  ,  steps.length )
              , _react2.default.createElement('span', { className: "form-signer--bar", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 488}}
                , _react2.default.createElement('i', { style: { width: `${(index / steps.length) * 100}%` }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 489}} )
              )
            )
            , _react2.default.createElement(Question, {
              step: step,
              value: step.kind === 'field' ? _nullishCoalesce(values[step.field.id], () => ( '')) : '',
              signerName: signerName,
              error: error,
              onValue: setValue,
              onSignerName: setName,
              onNext: next, __self: this, __source: {fileName: _jsxFileName, lineNumber: 492}}
            )
          )
        ) : (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement('h2', { className: "form-signer--question form-signer--focus" , tabIndex: -1, __self: this, __source: {fileName: _jsxFileName, lineNumber: 504}}, "Check your answers"  )
            ,  summary 
            , _react2.default.createElement('ul', { className: "form-signer--answers", 'aria-label': "Your answers" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 506}}
              ,  steps.map((s, i) => (
                _react2.default.createElement('li', { key: _nullishCoalesce(_optionalChain([s, 'access', _36 => _36.field, 'optionalAccess', _37 => _37.id]), () => ( 'signature')), __self: this, __source: {fileName: _jsxFileName, lineNumber: 508}}
                  , _react2.default.createElement('span', { className: "form-signer--answer-q", __self: this, __source: {fileName: _jsxFileName, lineNumber: 509}},  questionOf(s) )
                  , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'form-signer--answer', { 'form-signer--answer-sign': s.kind === 'signature' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 510}}
                    ,  s.kind === 'signature' ? signerName.trim() : answerText(s.field, values[s.field.id]) || 'Left empty' 
                  )
                  , _react2.default.createElement('button', { type: "button", className: "form-signer--change", disabled: sending, onClick: () => change(i), 'aria-label': `Change ${questionOf(s)}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 513}}, "Change"

                  )
                )
              )) 
            )
            ,  large && consent 
          )
        ) 
      )
      , _react2.default.createElement('div', { className: "form-signer--sr-only", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 523}},  spoken )
      , _react2.default.createElement('div', { className: "form-signer--footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 524}}
        ,  !large && consent 
        ,  serverError && _react2.default.createElement('div', { className: "form-signer--error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 526}},  serverError ) 
        , _react2.default.createElement('div', { className: "form-signer--buttons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 527}}
          ,  (index > 0 || onExit) && (
            _react2.default.createElement('button', { type: "button", className: "form-signer--back", disabled: sending, onMouseDown: keepFocus, onClick: back, __self: this, __source: {fileName: _jsxFileName, lineNumber: 529}}, "Back")
          ) 
          ,  step ? (
            _react2.default.createElement('button', { type: "button", className: "form-signer--next", onMouseDown: keepFocus, onClick: next, __self: this, __source: {fileName: _jsxFileName, lineNumber: 532}}, "Next")
          ) : (
            _react2.default.createElement('button', { type: "button", className: "form-signer--next", disabled: sending, onClick: submit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 534}}, "Sign and submit"  )
          ) 
        )
      )
    )
  )
}

exports. default = Signer
